import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import i18n from 'i18n';
import { CUSTOM_TABS_DIRECTION } from 'components/constants';
import CustomTabs from 'components/CustomTabs';
import i18nContext from 'components/i18n-context';
import { ROUTE_PATHS } from 'routes/constants';
import { Container } from 'uikit/Container/Container';
import './Settings.scss';

const SETTINGS_TABS = [
  {
    name: 'configuration',
    title: i18n.getMessage('settings.tab.configuration'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_CONFIGURATION
  },
  {
    name: 'paymentCutoffTimes',
    title: i18n.getMessage('settings.tab.paymentCutoffTimes'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_PAYMENTS_CUTOFF_TIMES
  },
  {
    name: 'blacklists',
    title: i18n.getMessage('settings.tab.blacklists'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_BLACKLISTS
  }
];

const Settings = () => {
  const i18n = useContext(i18nContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const path = location.pathname;

    const activeTabFromPath = SETTINGS_TABS.find((tab) => tab.route === path);
    if (activeTabFromPath) {
      setActiveTab(activeTabFromPath.name);
    } else if (path === ROUTE_PATHS.SETTINGS) {
      setActiveTab(SETTINGS_TABS[0].name);
      navigate(SETTINGS_TABS[0].route);
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    const selectedTab = SETTINGS_TABS.find((tab) => tab.name === tabName);
    if (selectedTab) {
      navigate(selectedTab.route);
    }
  };

  return (
    <section className={'right-section'}>
      <Container className={'settings-container'} header={i18n.getMessage('container.settings')}>
        <div className={'settings-wrapper'}>
          <CustomTabs
            tabList={SETTINGS_TABS}
            direction={CUSTOM_TABS_DIRECTION.HORIZONTAL}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
          />
          <Outlet />
        </div>
      </Container>
    </section>
  );
};

export default Settings;
